import { createSelector } from 'reselect';

import { getUser } from './selectors';

export function isUserLoggedIn() {
  return createSelector(getUser, 
    (user) => user !== null
  );
}
